      <!-- Paso 4: Completado -->
      <div *ngIf="view.currentStep === 3" class="step-complete" id="wizard-step-complete">
        <h1 class="step-title" id="wizard-step-complete-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-complete-description">{{ view.translate(view.steps[view.currentStep].description)
          }}</p>

        <div class="complete-illustration" id="wizard-complete-illustration">
          <i class="fas fa-check-circle" id="wizard-complete-icon"></i>
        </div>

        <div class="complete-summary" id="wizard-complete-summary">
          <h3 id="wizard-summary-title">{{ view.translate('wizard.summary_title') }}</h3>

          <div class="summary-item" id="wizard-summary-firstname">
            <div class="summary-label" id="wizard-summary-firstname-label">{{ view.translate('wizard.first_name') }}:</div>
            <div class="summary-value" id="wizard-summary-firstname-value">{{ view.wizardForm.get('firstName')?.value }}
            </div>
          </div>
          <div class="summary-item" id="wizard-summary-secondname">
            <div class="summary-label" id="wizard-summary-secondname-label">{{ view.translate('wizard.second_name') }}:</div>
            <div class="summary-value" id="wizard-summary-secondname-value">{{ view.wizardForm.get('secondName')?.value }}
            </div>
          </div>

          <div class="summary-item" id="wizard-summary-country">
            <div class="summary-label" id="wizard-summary-country-label">{{ view.translate('wizard.country') }}:</div>
            <div class="summary-value" id="wizard-summary-country-value">{{ view.wizardForm.get('country')?.value }}</div>
          </div>

          <div class="summary-item" id="wizard-summary-company">
            <div class="summary-label" id="wizard-summary-company-label">{{ view.translate('wizard.company') }}:</div>
            <div class="summary-value" id="wizard-summary-company-value">{{ view.wizardForm.get('company')?.value }}</div>
          </div>

          <div class="summary-item" id="wizard-summary-theme">
            <div class="summary-label" id="wizard-summary-theme-label">{{ view.translate('wizard.theme_preference') }}:</div>
            <div class="summary-value" id="wizard-summary-theme-value">{{ view.translate(view.wizardForm.get('theme')?.value ===
              'light' ? 'settings.light' : 'settings.dark') }}</div>
          </div>

          <div class="summary-item" id="wizard-summary-language">
            <div class="summary-label" id="wizard-summary-language-label">{{ view.translate('wizard.language_preference') }}:
            </div>
            <div class="summary-value" id="wizard-summary-language-value">
              {{ view.translate(
                view.wizardForm.get('language')?.value === 'es' ? 'settings.spanish' :
                view.wizardForm.get('language')?.value === 'en' ? 'settings.english' :
                view.wizardForm.get('language')?.value === 'pt' ? 'settings.portuguese' :
                view.wizardForm.get('language')?.value === 'fr' ? 'settings.french' :
                view.wizardForm.get('language')?.value === 'ja' ? 'settings.japanese' : 'settings.english'
              ) }}
            </div>
          </div>
          <div class="summary-item" id="wizard-summary-jobTitle">
            <div class="summary-label" id="wizard-summary-jobTitle-label">{{ view.translate('wizard.job_title') }}:</div>
            <div class="summary-value" id="wizard-summary-jobTitle-value">{{ view.wizardForm.get('jobTitle')?.value }}</div>
          </div>
          <div class="summary-item" id="wizard-summary-orgtype">
            <div class="summary-label" id="wizard-summary-orgtype-label">{{ view.translate('wizard.org_type') }}:</div>
            <div class="summary-value" id="wizard-summary-orgtype-value">{{ view.translate(view.organizationTypeLabel) }}</div>
          </div>
          <div class="summary-item" id="wizard-summary-orgsize">
            <div class="summary-label" id="wizard-summary-orgsize-label">{{ view.translate('wizard.org_size') }}:</div>
            <div class="summary-value" id="wizard-summary-orgsize-value">{{ view.translate(view.organizationSizeLabel) }}</div>
          </div>
          <div class="summary-item" id="wizard-summary-timezone">
            <div class="summary-label" id="wizard-summary-timezone-label">{{ view.translate('wizard.timezone') }}:</div>
            <div class="summary-value" id="wizard-summary-timezone-value">{{ view.wizardForm.get('timezone')?.value }}</div>
          </div>
          <div class="summary-item" id="wizard-summary-notifications">
            <div class="summary-label" id="wizard-summary-notifications-label">{{ view.translate('wizard.enable_notifications') }}:</div>
            <div class="summary-value" id="wizard-summary-notifications-value">{{ view.translate(view.wizardForm.get('notifications')?.value ? 'wizard.yes' : 'wizard.no') }}</div>
          </div>
          <div class="summary-item" id="wizard-summary-datacollection">
            <div class="summary-label" id="wizard-summary-datacollection-label">{{ view.translate('wizard.allow_data_collection') }}:</div>
            <div class="summary-value" id="wizard-summary-datacollection-value">{{ view.translate(view.wizardForm.get('dataCollection')?.value ? 'wizard.yes' : 'wizard.no') }}</div>
          </div>
        </div>

        <!-- Mensaje de error -->
        <div class="alert alert-danger wizard-provisioning-error" *ngIf="view.errorMessage" id="wizard-complete-error">
          <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
          <div class="wizard-provisioning-error-content" id="wizard-provisioning-error-content">
            <div class="wizard-provisioning-error-message" id="wizard-provisioning-error-message">{{ view.errorMessage }}</div>
            <div class="support-reference" *ngIf="view.supportReference" id="wizard-support-reference">
              <code class="support-reference-code" id="wizard-support-reference-code">{{ view.supportReference }}</code>
              <button type="button" class="btn btn-outline-secondary support-reference-copy"
                (click)="view.copySupportReference()" id="wizard-support-reference-copy">
                <i class="fas fa-copy" aria-hidden="true"></i>
                <span>{{ view.translate(view.supportReferenceCopied ? 'wizard.support_reference_copied' : 'wizard.copy_support_reference') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
